/**
 * Email-safe brand header. Uses <table> layout + <td> background + line-height
 * for vertical centring so it renders identically across Gmail, Outlook, Apple
 * Mail and Yahoo — none of which support flexbox in HTML email.
 *
 * Do NOT use inline SVG, base64 PNG or CSS grid — Gmail sanitises SVG and clips
 * base64 images above 8 KB on some clients.
 */
export function buildEmailLogoHTML() {
  return `<table role="presentation" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;">
    <tr>
      <td width="44" height="44" align="center" valign="middle" style="background:#FF5C39;border-radius:22px;color:#ffffff;font-family:Arial,Helvetica,sans-serif;font-size:22px;font-weight:800;line-height:44px;mso-line-height-rule:exactly;">&#10003;</td>
      <td style="padding-left:12px;" valign="middle">
        <div style="font-family:'Helvetica Neue',Arial,sans-serif;font-weight:800;font-size:16px;color:#1F0068;line-height:1.2;">Domestic Home Services</div>
        <div style="font-family:'Helvetica Neue',Arial,sans-serif;font-size:10px;letter-spacing:3px;font-weight:700;color:#FF5C39;text-transform:uppercase;line-height:1.4;margin-top:2px;">Everyday home protection</div>
      </td>
    </tr>
  </table>`;
}
